import { put } from '@core/api/baseApi';
import { AppVersion } from '@core/constants/appVersion';
import { CustomErroHandlerResponse } from '@core/types';

export const setViewerVersionSetting = (
  version: AppVersion,
): Promise<CustomErroHandlerResponse | undefined> =>
  put('/organizations/settings/viewer-version', { version });
